import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Auth Components
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Student Components
import StudentDashboard from './components/student/StudentDashboard';
import LessonViewer from './components/student/LessonViewer';

// Parent Components
import ParentDashboard from './components/parent/ParentDashboard';

// Admin Components
import AdminDashboard from './components/admin/AdminDashboard';

// Payment Components
import PaymentSuccess from './components/payment/PaymentSuccess';
import PaymentCancelled from "./components/payment/PaymentCancelled";

// Shared Components
import LandingPage from './components/shared/LandingPage';
import ErrorBoundary from './components/shared/ErrorBoundary';
import PrivacyPolicy from "./components/shared/PrivacyPolicy";

function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <Router>
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />

                        {/* Student Routes */}
                        <Route
                            path="/student/dashboard"
                            element={
                                <ProtectedRoute allowedRoles={['student']}>
                                    <StudentDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/lessons/:id"
                            element={
                                <ProtectedRoute allowedRoles={['student']}>
                                    <LessonViewer />
                                </ProtectedRoute>
                            }
                        />

                        {/* Parent Routes */}
                        <Route
                            path="/parent/dashboard"
                            element={
                                <ProtectedRoute allowedRoles={['parent', 'teacher']}>
                                    <ParentDashboard />
                                </ProtectedRoute>
                            }
                        />

                        {/* Admin Routes */}
                        <Route
                            path="/admin/dashboard"
                            element={
                                <ProtectedRoute allowedRoles={['admin']}>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />

                        {/* Payment Routes */}
                        <Route
                            path="/payment/success"
                            element={
                                <ProtectedRoute>
                                    <PaymentSuccess />
                                </ProtectedRoute>
                            }
                        />

                        <Route
                            path="/payment/cancelled"
                            element={
                                <ProtectedRoute>
                                    <PaymentCancelled />
                                </ProtectedRoute>
                            }
                        />

                        {/* 404 */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Router>
            </AuthProvider>
        </ErrorBoundary>
    );
}

export default App;